import React from "react";
import { ReactSVG } from "react-svg";
import { AlertProps } from "./types";
import { classNames, useTranslate } from "helpers";

const Alert: React.FC<AlertProps> = (props) => {
  const { title, message, variant, icon, className } = props;
  const { t } = useTranslate();

  const variantClassName = () => {
    switch (variant) {
      case "info":
        return "border border-blue-200 bg-blue-50 text-slate-800";
      case "warning":
        return "border border-yellow-200 bg-yellow-50 text-yellow-800";
      case "danger":
        return "border border-red-200 bg-red-50 text-red-800";
      case "success":
        return "border border-green-200 bg-green-50 text-green-800";
      default:
        return "";
    }
  };

  const variantIcon = () => {
    if (icon) return icon;

    switch (variant) {
      case "info":
        return  "media/icons/info.svg";
      case "warning":
        return "media/icons/warning.svg";
      case "danger":
        return "media/icons/error.svg";
      case "success":
        return "media/icons/check.svg";
      default:
        return null;
    }
  };

  const iconColorClass = () => {
    switch (variant) {
      case "info":
        return "text-blue-500  ";
      case "warning":
        return "text-yellow-500 ";
      case "danger":
        return "text-red-500";
      case "success":
        return "text-green-500";
      default:
        return "";
    }
  };

  return (
    <div
      className={classNames(
        "group w-full rounded-sm p-4 flex gap-3",
        variantClassName(),
        className
      )}
    >
      {icon && variantIcon() && (
        <ReactSVG
          src={variantIcon()!}
          className={classNames(
            "flex-shrink-0 w-6 h-6 mt-0.5 ",
            iconColorClass()
          )}
        />
      )}

      <div>
        {title && <h2 className="text-sm mb-0.5 font-semibold">{title}</h2>}
        {message && <p className="text-sm font-light">{message}</p>}
      </div>
    </div>
  );
};

export default Alert;


